export default "__VITE_ASSET__vgmuQQCc__"